import request from '@/utils/request';

export async function getPresignedUrl({ key, contentType }: { key: string; contentType: string }) {
  return request({
    method: 'POST',
    url: '/s3/presign',
    params: {},
    data: { key, contentType }, 
  });
} 